import { render } from "./ProfileT1View.vue?vue&type=template&id=4f8b9bff&scoped=true"
import script from "./ProfileT1View.vue?vue&type=script&lang=js"
export * from "./ProfileT1View.vue?vue&type=script&lang=js"

import "./ProfileT1View.vue?vue&type=style&index=0&id=4f8b9bff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8b9bff"]])

export default __exports__